import React, { useState, useEffect } from 'react';
import Button from 'react-bootstrap/Button';
import Logo from '../../../assets/images/Logo.svg';
import resetPassBanner from '../../../assets/images/reset-password-banner.png';
import Image from 'react-bootstrap/Image';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { Formik } from 'formik';
import { SvgIcons } from '../../../components/common/SvgIcons';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { verifyEmail } from '../../../services/authService';
import InputPassword from '../../../components/common/InputPassword';
import SnackbarToast from '../../../components/common/SnackBar';
import Loader from '../../../components/common/Loader';
import { ResetPasswordSchema } from '../../../validations/Auth';

export const VerifyEmail = () => {
    const { token } = useParams();
    const navigate = useNavigate()
    const [loading, setLoading] = useState(false);
    const [showSnackBar, setshowSnackBar] = useState({
        show: false,
        message: "",
        severity: ""
    });
    const handleClose = () => {
        setshowSnackBar({
            show: false,
            message: "",
            severity: ""
        })
    }

    useEffect(() => {
        verifyUserEmail();
    }, [token])

    
    /**
     * Submit Method to call when user clicks on Reset password button
     * @date 15/02/2023 - 19:14:03
     *
     * @async
     * @param {string} password
     * @returns {*}
     */
    const verifyUserEmail = async () => {
        setLoading(true);
        
        
        verifyEmail({ 'token': token ? token : '' }).then(response => {
            setshowSnackBar({
                show: true,
                message: "Your Account is Successfully Activated",
                severity: 'success'
            });

            setTimeout(() => {
              // navigate('/');
            }, 1000)
        }).catch(error => {
            setLoading(false);
            setshowSnackBar({
                show: true,
                message: error.response.data.message,
                severity: 'error'
            });
        })
    }

    return (
        <>
            <SnackbarToast showSnackBar={showSnackBar} handleClose={handleClose} />       
            <Loader isLoading={loading} />
        </>
    )
}